import $ from 'jquery'

const initRegistration = (wrap: HTMLElement) => {
  const form = wrap.querySelector('form')
  if (!form) {
    return
  }

  const nonceValues = {}
  $(form)
    .find<HTMLInputElement>('input[type="hidden"]')
    .each(function () {
      if (this.name.startsWith('_')) {
        nonceValues[this.name] = this.value
      }
    })

  $(form)
    .find('select')
    .each(function (this: HTMLSelectElement) {
      this.title = this.title || 'Bitte wählen…'
      $(this).val('')
    })
}

// ACF Type patches
declare global {
  interface Window {
    acf?: {
      unload: {
        active: boolean
      }
      addAction: (
        name: string,
        action: (field: {
          $el: JQuery<HTMLElement>
          notice: {
            $el: JQuery<HTMLElement>
          }
        }) => unknown
      ) => unknown
    }
  }
}

const initAcf = () => {
  const { acf } = window
  if (!acf) {
    return
  }

  acf.unload.active = false
  acf.addAction('invalid_field', function (field) {
    field.notice.$el.addClass('invalid-feedback')
    // console.log(field.$el);
  })
}

$(() => {
  initAcf()

  $('#user-registration').each(function () {
    initRegistration(this)
  })
})

// check on page load if the activation was successful
// success is defined in the template

window.onload = () => {
  const activateSuccess = document.getElementById('activate-success')
  const activateError = document.getElementById('activate-error')
  if (activateSuccess && activateError) {
    /* @ts-ignore */
    if (activationSuccess) {
      activateSuccess.classList.remove('d-none')
    } else {
      activateError.classList.remove('d-none')
    }
  }
}
